import styled from 'styled-components/native';
import style, { hpx } from '../../styles/index';

export const Container = styled.View`
  background: ${style.colors.white};
  flex: 1;
`;

export const HeaderCart = styled.View`
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 60px;
  border-bottom-width: 1px;
  border-bottom-color: #f0f0f0;
  margin-bottom: 0;
  position: relative;
`;

export const Title = styled.Text`
  color: #333;
  font-family: ${style.fontName.ubuntuBold};
  font-size: ${style.fonts.large};
`;

export const ItemsContainer = styled.ScrollView`
  background: ${style.colors.white};
  padding: 20px;
`;

export const ButtonContainer = styled.View`
  border-top-width: 1px;
  border-color: #f0f0f0;
  padding: 20px;
  background-color: white;
  elevation: 20;
  box-shadow: 0px -5px 15px rgba(0, 0, 0, 0.05);
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
`;

export const TotalContainer = styled.View`
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 12px;
`;

export const TotalTitle = styled.Text`
  color: #666;
  font-family: ${style.fontName.ubuntuRegular};
  font-size: ${style.fonts.medium};
`;

export const TotalPrice = styled.Text`
  color: ${props => props.theme.colors.primary};
  font-family: ${style.fontName.ubuntuBold};
  font-size: ${style.fonts.medium};
`;

export const Label = styled.Text`
  color: #333;
  font-family: ${style.fontName.ubuntuBold};
  font-size: ${style.fonts.large};
  margin-bottom: 15px;
  margin-top: 10px;
`;

export const ConfirmContainer = styled.View`
  color: ${props => props.theme.colors.primary};
  font-family: ${style.fontName.ubuntuBold};
  font-size: ${style.fonts.medium};
`;

export const InputTextContainer = styled.View`
  padding: 10px;
  margin-bottom: 10px;
`;

export const InputText = styled.TextInput`
  font-family: ${style.fontName.ubuntuRegular};
  font-size: ${style.fonts.medium};
  padding: 12px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  margin-bottom: 10px;
  background-color: #f9f9f9;
  min-width: 270px;
`;

export const CloseButton = styled.TouchableOpacity`
  align-self: flex-end;
  padding: 10px;
`;
